import { Component, OnInit } from '@angular/core';
import { Prize } from '../prize.model';
import { PrizesService } from '../prizes.service';
import {environment} from '../../../../environments/environment';
import { ToastyService } from 'ng2-toasty';

@Component({
  selector: 'app-all-prizes',
  templateUrl: './all-prizes.component.html',
  styleUrls: ['./all-prizes.component.scss']
})
export class AllPrizesComponent implements OnInit {

  prizes: Prize[] = [];
  environment = environment;
  lastExp = null;
  prizeSelected = null;

  constructor( private prizeService: PrizesService, private toastyService: ToastyService) { }

  ngOnInit(): void {
    this.prizeService.getAllPrizes()
    .subscribe((res: {data: Prize[], message: string}) => {
      this.prizes = res.data;
    });
    this.lastExp = JSON.parse(localStorage.getItem('LastExperience'));
  }

  deletePrize(id: number): void {
    this.prizeService.deletePrize(id)
    .subscribe((res: any) => {
      this.prizes = this.prizes.filter(p =>p.id !== id);
      this.toastyService.success({
        title: 'Prize eliminato',
        msg: 'Il tuo prize "<b>' + res.data.title + '</b>" è stato eliminato.'
      });
    },
    (err) => {
      console.log('Errore ', err.error.message);
    });
  }

}
